export default __webpack_public_path__ + "static/media/bg1.c9dbeb98.png";